
import { Base } from '../core/base.model';
import { Version } from '../gestion-proyectos/etapa/version.model';
import { Usuario } from './usuario.model';
import { EvidenciaBean } from '../incidencias/evidenciaBean.model';


export class incidenciaDetalleQABean extends Base{
     id: number;
     descripcion: string;
     evidencia: string;
     /** Ids de versión en texto: UUID de Mongo, el id numérico de cos_version o el centinela PENDIENTE_VERSION (T3b). */
     id_version_incidencia: string;
     id_version_resuelto: string;
     fecha_creacion: string;
     id_usuario_autor: number;
     id_incidencia: number;
     origen_cliente: string;

     versionResueltoBean: Version;
     versionDetectadoBean: Version;
     usuarioBean: Usuario;
     evidenciaBean: EvidenciaBean;
      listaEvidencias: Array<EvidenciaBean>;
     //listaEvidencias: evidenciaBean[];
}